<template>
  <v-app>
 

  <!-- Sizes your content based upon application components -->
  <v-main  style="background-color:#F3F3F4" >
                   
      
        <v-container  fill-height >

          <!-- <v-card outlined style="background-color:#F3F3F4" > -->
           <v-container   >
             <form role="form" @submit.prevent="solicitar" >
              <v-row>
                
                  <v-col              
                  cols="12"
                  md="12"
                  align="center"
                  justify="center"
                >
                  <v-img                
                    max-height="100"
                    max-width="150"
                    width="150"
                  src="logo3mm.png"
                  ></v-img>
                </v-col>
              </v-row>


              <v-row  align="center"
                  justify="center">
              
                <v-col              
                  :md="colunas"   
                  align="center"
                  justify="center"
                  style="color:#627AAD"        
                >
                <strong> {{nameApp}} </strong>
                </v-col>
              </v-row>


              <v-row  align="center"
                  justify="center">
              
                <v-col              
                  :md="colunas"   
                  align="center"
                  justify="center"                     
                >
                 Alterar Senha
                </v-col>
              </v-row>

              <v-row  align="center"
                  justify="center">
              
                <v-col              
                  :md="colunas"              
                >
                  <v-text-field
                      ref="password"
                      label="Senha"
                      placeholder="Senha"
                      name="password_new" 
                      @change="$v.data.password_new.$touch()"                      
                      v-model="data.password_new"
                      type="password" 
                    ></v-text-field>
                </v-col>
              </v-row>


              <v-row  align="center"
                  justify="center">
              
                <v-col              
                  :md="colunas"              
                >
                  <v-text-field                      
                      label="Repetir Senha"
                      placeholder="Repetir Senha"
                      name="password_new_again" 
                      @change="$v.data.password_new_again.$touch()"                      
                      v-model="data.password_new_again"
                      type="password" 
                    ></v-text-field>
                </v-col>
              </v-row>

              <v-row  align="center"
                  justify="center">        

                <v-col              
                  :md="colunas"
                  >                  
                  <v-btn color="primary" width="100%" :disabled="$v.$invalid || $v.$error" type="submit" >    
                      Alterar Senha       
                    </v-btn>
                </v-col>
              </v-row>

              
              <v-row  align="center"
                  justify="center">
              
                <v-col              
                  :md="colunas"
                  align="center"
                  justify="center"  
                  class="text-caption"         
                >
                 {{nameApp}} - {{companyDeveloper}} © {{ano}}
                </v-col>
              </v-row>
          <!-- </v-card> -->
             </form>
           </v-container>
        </v-container>
      
  
  </v-main>

  <!-- <v-footer app>
    <! -- -- >
  </v-footer> -->
</v-app>
</template>


<script>


import {required} from 'vuelidate/lib/validators';
import axios from 'axios';


export default{
    data(){
        return {
            data: {
              password_new:'',
              password_new_again:'',
              token:''
            },
            colunas: '4'            
        }
    },
    computed: {
        nameApp(){
          return this.$store.getters['app/nameApp'];
        },
        companyDeveloper(){
          return this.$store.getters['app/companyDeveloper'];
        },
        ano(){          
          var d = new Date();
          return d.getFullYear(); 
        } 
    },
    methods:{        
        solicitar(){
            console.log(this.email);
            // this.$store.dispatch('app/login',{
            //      email: this.email,
            //      password: this.password
            // });

            if(this.data.password_new_again != this.data.password_new){
								this.$toastr('error',"As senhas devem ser iguais.");
								return;
						}

            if(this.data.password_new_again.length < 8){
              this.$toastr('error',"A senha deve ter no mínimo 8 caracteres.");
              return;
            }	
              
            if (!this.$v.$error) {		
              axios.post('auth/changepassword', this.data)
                .then( res=>{
                  if( res.data && res.data.success){
                    this.$toastr('success', "Senha alterada com sucesso.");
                    this.$router.push({ name: 'login'});
                  } else {
                    console.log('er', res);
                    this.$toastr('error',"Operação não completada, por favor solicite um novo email de alteração de senha.");
                  }
                }, err => {
                    console.log('er2', err);
                    this.$toastr('error',"Operação não completada, por favor solicite um novo email de alteração de senha.");
                });
            }else{
              this.$toastr('error',"Informe os dados corretamente.");
            }
        }
    },
    created(){          
      if(this.$route.query.change && this.$route.query.change!=''){
        this.data.token = this.$route.query.change;
      }else{
        this.$router.push({ name: 'login'});
      }
       // console.log('ref',this.$refs);
       // nextTick executa após o DOM se montado, então nesse momento o objeto login existe
       this.$nextTick(() =>  this.$refs.password.focus() );
    },
    validations:{
      data :{     
        password_new_again:{
          required      
        },
        password_new:{
          required      
        }     
      }
    },
    
}
</script>
